import { render, staticRenderFns } from "./prisLogo.vue?vue&type=template&id=50da57f6&"
import script from "./prisLogo.vue?vue&type=script&lang=js&"
export * from "./prisLogo.vue?vue&type=script&lang=js&"
import style0 from "./prisLogo.vue?vue&type=style&index=0&id=50da57f6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports